const questions = [
  // --- Personal Information ---
  {
    id: "age",
    section: "Personal Information",
    text: "What is your age?",
    type: "number",
    min: 18,
    max: 120,
  },
  {
    id: "sex",
    section: "Personal Information",
    text: "What is your sex?",
    type: "radio",
    options: ["Female", "Male", "Other", "Prefer not to say"],
  },
  {
    id: "current_weight",
    section: "Personal Information",
    text: "What is your current weight?",
    type: "weight",
    minMetric: 25,
    maxMetric: 350,
    minImperial: 55,
    maxImperial: 770,
  },
  {
    id: "height",
    section: "Personal Information",
    text: "What is your height?",
    type: "height",
    minMetric: 100,
    maxMetric: 250,
    minImperial: 39,
    maxImperial: 98,
  },
  {
    id: "usual_weight",
    section: "Personal Information",
    text: "What was your usual (pre-illness) weight?",
    type: "weight",
    minMetric: 25,
    maxMetric: 350,
    minImperial: 55,
    maxImperial: 770,
  },

  // --- Food Preferences Drill-Down ---
  {
    id: "favorite_food_groups",
    section: "Preferences & Lifestyle",
    text: "Which types of foods do you enjoy eating most right now? Select all that apply.",
    type: "food-group-multiselect",
    options: [
      "Meat/Poultry/Fish",
      "Vegetables",
      "Fruits",
      "Dairy",
      "Grains/Bread/Pasta",
      "Eggs",
      "Legumes (beans, lentils)",
      "Sweets/Desserts",
      "Snacks",
      "Beverages (coffee, tea, juice, etc.)",
      "Other"
    ]
  },
  {
    id: "favorite_food_details",
    section: "Preferences & Lifestyle",
    text: "Tell us more about your favorites! For each group you selected, pick the foods you like most.",
    type: "food-group-details"
  },

  // --- Symptoms & Side Effects ---
  {
    id: "symptoms",
    section: "Symptoms & Side Effects",
    text: "Are you experiencing any eating-related symptoms?",
    type: "radio",
    options: ["Yes", "No"],
    skipNextIfNo: 1,
  },
  {
    id: "symptom_list",
    section: "Symptoms & Side Effects",
    text: "Which symptoms?",
    type: "checkbox",
    options: [
      "Loss of appetite",
      "Nausea or vomiting",
      "Sore mouth or throat",
      "Dry mouth (xerostomia)",
      "Oral thrush or mouth sores",
      "Difficulty swallowing",
      "Changes in taste or smell",
      "Bloating or early fullness",
      "Diarrhea",
      "Constipation",
      "Fatigue",
      "None"
    ],
    skipIfNo: "symptoms",
  },
  {
    id: "fluid_tolerance",
    section: "Symptoms & Side Effects",
    text: "Do you have difficulty tolerating fluids or experience dehydration?",
    type: "radio",
    options: [
      "Yes, fluids cause nausea or vomiting",
      "Yes, limited to certain fluids",
      "No issues",
    ],
    skipIfNo: "symptoms",
  },
  {
    id: "weight_changes",
    section: "Symptoms & Side Effects",
    text: "Are you currently experiencing unintentional weight changes?",
    type: "radio",
    options: [
      "Weight loss >5% in last month",
      "Stable weight",
      "Weight gain",
    ],
  },

  // --- Cancer Treatment ---
  {
    id: "treatments",
    section: "Cancer Treatment",
    text: "Which cancer treatments are you undergoing or have undergone recently?",
    type: "checkbox",
    options: [
      "Chemotherapy",
      "Radiation therapy",
      "Immunotherapy",
      "Surgery (recent or upcoming)",
      "Hormone therapy (e.g., aromatase inhibitors)",
      "Targeted therapy (e.g., tyrosine kinase inhibitors)",
      "Stem cell or bone marrow transplant",
      "None",
    ],
  },
  {
    id: "medications",
    section: "Cancer Treatment",
    text: "Which medications are you taking that may affect food choices?",
    type: "checkbox",
    options: [
      "Methotrexate (avoid high-folate foods)",
      "Corticosteroids (e.g., prednisone; monitor sodium/sugar)",
      "Tamoxifen (avoid grapefruit)",
      "Opioids (e.g., morphine; may cause constipation)",
      "Anti-nausea drugs (e.g., ondansetron)",
      "Anti-diarrheal medications",
      "Proton pump inhibitors (PPIs)",
      "Antibiotics",
      "Immunosuppressants",
      "Anticoagulants (e.g., warfarin; watch vitamin K intake)",
      "None",
    ],
  },

  // --- GI & Dietary Restrictions ---
  {
    id: "gi_conditions",
    section: "GI & Dietary Restrictions",
    text: "Do you have any other gastrointestinal (GI) conditions that affect your eating?",
    type: "checkbox",
    options: [
      "Gastroesophageal reflux disease (GERD)",
      "Irritable bowel syndrome (IBS)",
      "Crohn's disease or colitis",
      "Other",
      "None",
    ],
    freeTextForOther: true,
  },
  {
    id: "dietary_restrictions",
    section: "GI & Dietary Restrictions",
    text: "Which dietary restrictions do you have?",
    type: "checkbox",
    options: [
      "Vegetarian",
      "Vegan",
      "Gluten-free",
      "Lactose intolerant",
      "Low sodium / low salt",
      "Diabetic-friendly",
      "Low fiber / low residue",
      "Renal diet",
      "None",

    ],
  },

  // --- Allergies ---
  {
    id: "food_allergies",
    section: "Allergies",
    text: "Which food allergies do you have?",
    type: "checkbox",
    options: [
      "Peanuts",
      "Tree nuts",
      "Shellfish",
      "Fish",
      "Milk",
      "Eggs",
      "Soy",
      "Wheat",
      "Gluten",
      "Sesame",
      "Other",
      "None",
    ],
    freeTextForOther: true,
  },
  {
    id: "allergy_severity",
    section: "Allergies",
    text: "What is the severity of your food allergies?",
    type: "radio",
    options: [
      "Mild",
      "Moderate",
      "Severe (e.g., anaphylactic)",
      "No allergies",
    ],
  },
  {
    id: "cross_contamination",
    section: "Allergies",
    text: "Do you have concerns about cross-contamination with allergens?",
    type: "radio",
    options: ["Yes, avoid shared cooking surfaces/utensils", "No", "Not sure"],
  },

  // --- Supplements & Eating Habits ---
  {
    id: "supplements",
    section: "Supplements & Eating Habits",
    text: "Do you currently use any nutritional supplements or special formulas?",
    type: "checkbox",
    options: [
      "Oral nutritional supplements (e.g., Ensure, Boost)",
      "Tube feeding (enteral nutrition)",
      "Parenteral nutrition (IV nutrition)",
      "None",
    ],
  },
  {
    id: "meal_frequency",
    section: "Supplements & Eating Habits",
    text: "How many meals/snacks can you eat per day?",
    type: "radio",
    options: ["2–3 meals", "4–6 smaller meals/snacks", "Varies", "Only liquids or pureed foods"],
  },
  {
    id: "kitchen_equipment",
    section: "Supplements & Eating Habits",
    text: "Which of the following equipment or preparation methods can you use right now? Select all that apply.",
    type: "checkbox",
    options: [
      "I have a full kitchen and can cook most meals",
      "Stove (can boil, sauté, fry, etc.)",
      "Oven (can bake or roast)",
      "Microwave",
      "Toaster or toaster oven",
      "Air fryer",
      "Slow cooker or Instant Pot",
      "Blender or food processor",
      "No-cook (can assemble meals without heat, e.g., salads, sandwiches)",
      "Only able to eat ready-made/prepared/delivered meals"
    ]
  },
  {
    // --- Preferences & Lifestyle ---
    id: "food_preferences",
    section: "Preferences & Lifestyle",
    text: "Which best describes your food preferences?",
    type: "radio",
    options: [
      "Bland or mild flavors",
      "Strong or savory flavors",
      "Sweet flavors",
      "Tart or citrusy flavors (if no sore mouth)",
      "Avoid spicy foods",
      "No preference",
    ],
  },
  {
    id: "activity_level",
    section: "Preferences & Lifestyle",
    text: "How active are you generally?",
    type: "radio",
    options: [
      "Sedentary (little or no exercise)",
      "Light activity (light exercise/sports 1–3 days/week)",
      "Moderate activity (moderate exercise/sports 3–5 days/week)",
      "Very active (hard exercise/sports 6–7 days/week)",
    ],
  },
  {
    id: "mental_health",
    section: "Preferences & Lifestyle",
    text: "Do you experience anxiety, depression, or stress that affects your appetite or eating?",
    type: "radio",
    options: ["Yes, significantly", "Yes, mildly", "No"],
  },
  {
    id: "sleep_quality",
    section: "Preferences & Lifestyle",
    text: "How would you describe your usual sleep?",
    type: "radio",
    options: [
      "Good, restful sleep most nights",
      "Somewhat disturbed sleep",
      "Poor sleep, frequent waking",
      "Severe sleep problems/insomnia"
    ],
  },

  // --- Fluids & Sugar ---
  {
    id: "fluid_intake",
    section: "Fluids & Sugar",
    text: "How much fluid do you typically drink daily?",
    type: "radio",
    options: ["Less than 1 liter", "1–2 liters", "More than 2 liters"],
  },
  {
    id: "sugar_limit",
    section: "Fluids & Sugar",
    text: "Do you need to limit sugar intake beyond diabetic-friendly restrictions?",
    type: "radio",
    options: ["Yes", "No", "Not sure"],
  },
  {
    id: "additional_info",
    section: "Culture & Other",
    text: "Is there anything else about your eating, health, or preferences you'd like your dietitian to know, cultural or religious dietary preferences or restrictions?",
    type: "textarea",
  }
];

export default questions;
